/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import {subscribe, unsubscribe, Flyout, mediaQueries, publish } from '../twd'


export default () => {
    const [el, setEl] = React.useState(null)
    const [args, setArgs] = React.useState(null)

    React.useEffect(() => {
        let subId = subscribe('show_flyout.app', ({el, ...args}) => {
            publish('hide_flyout')

            setEl(el)
            setArgs(args)
        })
        return () => {
            unsubscribe(subId)
        }
    }, [el])


    return <React.Fragment>
    {el && <Flyout
        anchorEl={el}
        autoShow={true}
        trigger={["hover"]}
        contentStyle={{maxWidth:'600px', width:'fit-content'}}
        popperStyles={{
            maxWidth:`${Math.min(mediaQueries.width()-40, 600)}px`,
        }}
        onHide={() => {
            setEl(null)
            setArgs(null)
        }}
        {...args}
    />}
    </React.Fragment>
}